import * as Yup from 'yup'

export const loginValidationSchema = Yup.object().shape({
  username: Yup.string('Email is required.')
    .email('This must be an email address.')
    .required('Email is required.'),
  password: Yup.string('Password is required.').required(
    'Password is required.'
  ),
})